export const HEADQUARTERS_ID = 3;
export const DEV_CENTER_ID = 1;
export const REPRESENTATIVE_ID = 2;

export const HEADQUARTERS_ICON =
  'https://content.andersenlab.com/common-data/office-category-icons/headquarters/1762778491.svg';
export const DEV_CENTER_ICON =
  'https://content.andersenlab.com/common-data/office-category-icons/development-center/1754650800.svg';

export const CATEGORY_ORDER = [HEADQUARTERS_ID, DEV_CENTER_ID, REPRESENTATIVE_ID];
